import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FilePreviewModal } from '../FilePreview';

interface FileItemProps {
  file: File;
  onRemove: () => void;
}

export const FileItem: React.FC<FileItemProps> = ({ file, onRemove }) => {
  const [showPreview, setShowPreview] = useState(false);
  
  const isVideo = file.type.startsWith('video/');
  const isPdf = file.type === 'application/pdf';
  
  const getFileIcon = () => {
    if (isPdf) {
      return '/hub/tracks/pdf-file.svg';
    }
    if (isVideo) {
      return '/hub/tracks/video-file.svg';
    }
    return '/hub/tracks/pdf-file.svg'; 
  };

  const handleFileClick = () => {
    if (isVideo || isPdf) {
      setShowPreview(true);
    }
  };

  const formatFileName = (name: string) => {
    if (name.length > 30) {
      return name.substring(0, 27) + '...';
    }
    return name;
  };

  return (
    <>
      <div
        className="d-none d-sm-flex"
        style={{
          alignItems: 'center',
          gap: '4px',
          marginBottom: '8px',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '12px 16px',
            backgroundColor: '#F7F8F9',
            borderRadius: '8px',
            cursor: isVideo || isPdf ? 'pointer' : 'default',
            flex: 1,
            minWidth: 0,
          }}
          onClick={handleFileClick}
        >
          <img
            src={getFileIcon()}
            alt={isVideo ? 'Vídeo' : isPdf ? 'PDF' : 'Arquivo'}
            style={{ width: '20px', height: '20px', marginRight: '12px', flexShrink: 0 }}
          />
          <span
            style={{
              color: '#464646',
              fontSize: '14px',
              fontWeight: '400',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {formatFileName(file.name)}
          </span>
        </div>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          style={{
            width: '40px',
            height: '48px',
            backgroundColor: '#00599C',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
          aria-label="Remover arquivo"
        >
          <FontAwesomeIcon icon={faTimes} style={{ fontSize: '18px', color: 'white' }} />
        </button>
      </div>

      <div
        className="d-sm-none"
        style={{ marginBottom: '8px' }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#F7F8F9',
            borderRadius: '8px',
            overflow: 'hidden',
            width: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '12px 16px',
              flex: 1,
              minWidth: 0,
              cursor: isVideo || isPdf ? 'pointer' : 'default',
            }}
            onClick={handleFileClick}
          >
            <img
              src={getFileIcon()}
              alt={isVideo ? 'Vídeo' : isPdf ? 'PDF' : 'Arquivo'}
              style={{ width: '20px', height: '20px', marginRight: '12px', flexShrink: 0 }}
            />
            <span
              style={{
                color: '#464646',
                fontSize: '14px',
                fontWeight: '400',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {formatFileName(file.name)}
            </span>
          </div>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onRemove(); }}
            style={{
              width: '48px',
              height: '48px',
              backgroundColor: '#00599C',
              border: 'none',
              borderLeft: '1px solid rgba(0,0,0,0.08)',
              borderRadius: '0 8px 8px 0',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
            aria-label="Remover arquivo"
          >
            <FontAwesomeIcon icon={faTimes} style={{ fontSize: '18px', color: 'white' }} />
          </button>
        </div>
      </div>

      <FilePreviewModal
        show={showPreview}
        onHide={() => setShowPreview(false)}
        file={file}
      />
    </>
  );
};
